export enum ServicePayment {
  Reservation_Event = 1,
  Membership,
  Products,
}
